<template>
  <v-container class="logo">
    <router-link :to="getHomeLink()" tag="span" style="cursor: pointer">
      <v-img contain src="@/assets/logo.png"></v-img>
    </router-link>
  </v-container>
</template>

<script>
export default {
  name: "LogoText",
  methods: {
    getHomeLink: function() {
      return "/" + this.$i18n.locale + "/";
    }
  }
};
</script>

<style scoped>
.logo {
  height: 80px;
  width: 80px;
  padding: 5px;
  padding-right: 15px;
}
</style>
